import React, { useState } from "react";
import { KpiIcon } from "../../KpiIcons";
import { getMimeLabel } from "./utils";
import DocumentPreviewModal from "../../../../components/DocumentPreviewModal";

const DocumentViewerPanel = ({ document: doc }) => {
  const [previewOpen, setPreviewOpen] = useState(false);

  if (!doc) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 8,
          padding: "20px 16px",
          border: "1.5px dashed var(--bdr)",
          borderRadius: 10,
          background: "var(--bdr2)",
          textAlign: "center",
        }}
      >
        <div
          style={{
            width: 32,
            height: 32,
            minWidth: 32,
            minHeight: 32,
            maxWidth: 32,
            maxHeight: 32,
            borderRadius: 8,
            background: "var(--ink4)15",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
            overflow: "hidden",
          }}
        >
          <KpiIcon name="upload" size={14} color="var(--ink4)" />
        </div>
        <div style={{ fontSize: 12, fontWeight: 600, color: "var(--ink4)" }}>
          No document uploaded
        </div>
        <div style={{ fontSize: 11, color: "var(--ink4)", opacity: 0.7 }}>
          No proof document was attached to this answer
        </div>
      </div>
    );
  }

  const fileMeta = doc.fileMetadata || {};
  const meta = doc.documentMetadata || {};
  const url = fileMeta.url || meta.url || "";
  const mime = fileMeta.mimeType || meta.mimeType || "";
  const name = fileMeta.fileName || meta.fileName || "Document";
  const size = fileMeta.fileSize
    ? `${Math.round(Number(fileMeta.fileSize) / 1024)} KB`
    : meta.fileSize
    ? `${Math.round(Number(meta.fileSize) / 1024)} KB`
    : "";
  const typeLabel = getMimeLabel(mime);

  return (
    <div className="ahp-doc-card">
      <div className="ahp-doc-hd">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            minWidth: 0,
            flex: 1,
          }}
        >
          <div
            style={{
              width: 28,
              height: 28,
              minWidth: 28,
              minHeight: 28,
              maxWidth: 28,
              maxHeight: 28,
              borderRadius: 7,
              background: "var(--blue3)",
              border: "1px solid var(--blue2)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
              overflow: "hidden",
            }}
          >
            <span style={{ fontSize: 12 }}>📎</span>
          </div>
          <div style={{ minWidth: 0 }}>
            <div
              style={{
                fontSize: 12,
                fontWeight: 700,
                color: "var(--ink)",
                lineHeight: 1.3,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                maxWidth: 280,
              }}
            >
              {name}
            </div>
            <div style={{ fontSize: 10, color: "var(--ink4)", marginTop: 1 }}>
              {typeLabel}
              {size ? ` · ${size}` : ""}
              {doc.documentType ? ` · ${doc.documentType}` : ""}
            </div>
          </div>
        </div>

        <div style={{ display: "flex", gap: 6, flexShrink: 0 }}>
          {url && (
            <a
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className="ahp-open-link"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 5,
                padding: "5px 11px",
                borderRadius: 7,
                background: "var(--blue3)",
                border: "1px solid var(--blue2)",
                color: "var(--blue)",
                fontSize: 11,
                fontWeight: 700,
                textDecoration: "none",
                transition: "background .12s",
              }}
            >
              ↗ Open
            </a>
          )}
          {url && (
            <button
              onClick={() => setPreviewOpen(true)}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 5,
                padding: "5px 11px",
                borderRadius: 7,
                background: "transparent",
                border: "1.5px solid var(--bdr)",
                color: "var(--ink3)",
                fontSize: 11,
                fontWeight: 700,
                cursor: "pointer",
                fontFamily: "var(--ff)",
                transition: "background .12s",
              }}
            >
              👁 Preview
            </button>
          )}
        </div>
      </div>

      <DocumentPreviewModal
        document={previewOpen ? doc : null}
        onClose={() => setPreviewOpen(false)}
      />
    </div>
  );
};

export default DocumentViewerPanel;
